
import { Calendar, User, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BlogSection = () => {
  const { t } = useTranslation();

  const blogPosts = [
    {
      id: 1,
      title: t('blog.post1.title'),
      excerpt: t('blog.post1.excerpt'),
      author: t('blog.post1.author'),
      date: t('blog.post1.date'),
      image: 'https://public.readdy.ai/ai/img_res/2f2bd087449d8c627a9fac4837969a13.jpg',
      category: t('blog.post1.category')
    },
    {
      id: 2,
      title: t('blog.post2.title'),
      excerpt: t('blog.post2.excerpt'),
      author: t('blog.post2.author'),
      date: t('blog.post2.date'),
      image: 'https://readdy.ai/api/search-image?query=Business%20professional%20climbing%20career%20ladder%20with%20certificates%20and%20achievements%2C%20corporate%20office%20environment%20with%20success%20symbols%20and%20professional%20development%20materials%2C%20inspiring%20career%20growth%20concept&width=400&height=250&seq=blog2&orientation=landscape',
      category: t('blog.post2.category')
    },
    {
      id: 3,
      title: t('blog.post3.title'),
      excerpt: t('blog.post3.excerpt'),
      author: t('blog.post3.author'),
      date: t('blog.post3.date'),
      image: 'https://readdy.ai/api/search-image?query=Student%20successfully%20completing%20online%20course%20with%20study%20tips%20and%20learning%20strategies%20visible%20on%20screen%2C%20organized%20study%20space%20with%20notes%20and%20educational%20resources%2C%20productive%20learning%20atmosphere&width=400&height=250&seq=blog3&orientation=landscape',
      category: t('blog.post3.category')
    }
  ];

  return (
    <section id="blog" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('blog.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('blog.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <div className="relative h-48">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {post.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-2">
                    <User className="w-4 h-4" />
                    <span>{post.author}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Calendar className="w-4 h-4" />
                    <span>{post.date}</span>
                  </div>
                </div>
                
                <button className="flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                  <span>{t('blog.readMore')}</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
